/**
 * ═══ LES ANCRES DE LA PROSE ═══
 *
 * Le sommaire d'une section est DÉRIVÉ de ses titres : l'organisateur
 * écrit des `h3`, il obtient un plan, aucune saisie de plus. Il faut donc fabriquer
 * un identifiant d'ancre à partir d'un titre, et le fabriquer PAREIL à chaque rendu,
 * sinon les liens du sommaire visent des ancres d'un rendu précédent.
 */

/** `« Accès & horaires »` → `se-acces-horaires`. Le préfixe évite de percuter un id du site. */
export function titleKey(text: string | null): string {
  const key = (text ?? "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
  return `se-${key || "section"}`;
}

/**
 * Le même titre écrit deux fois donnerait deux ancres identiques, et le second lien
 * du sommaire ramènerait au premier. Le prototype avait ce défaut ; on suffixe.
 */
export function freeId(wanted: string, taken: ReadonlySet<string>): string {
  if (!taken.has(wanted)) return wanted;
  let n = 2;
  while (taken.has(`${wanted}-${n}`)) n += 1;
  return `${wanted}-${n}`;
}
